import script from "./data-preview.vue?vue&type=script&lang=ts&setup=true"
export * from "./data-preview.vue?vue&type=script&lang=ts&setup=true"

import "./data-preview.vue?vue&type=style&index=0&id=251d1da7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-251d1da7"]])

export default __exports__